import { DomSanitizer } from '@angular/platform-browser';
import { base64ToFile, ImageCroppedEvent } from 'ngx-image-cropper';

export function blobResponseToFile(
    response: Blob | File,
    source?: { name?: string; fileName?: string; mimeType?: string; extension?: string },
): File {
    if (response instanceof File) {
        return response;
    }

    const name = source?.fileName || source?.name || 'image.jpg';
    const type = response.type || source?.mimeType || mimeTypeFromExtension(source?.extension) || 'image/jpeg';

    return new File([response], name, { type });
}

function mimeTypeFromExtension(extension?: string): string | undefined {
    switch (extension?.toLowerCase()) {
        case 'png':
            return 'image/png';
        case 'gif':
            return 'image/gif';
        case 'jpg':
        case 'jpeg':
            return 'image/jpeg';
        default:
            return undefined;
    }
}

export function resolveCroppedImageFromEvent(
    event: ImageCroppedEvent,
    sourceFile: File | undefined,
    sanitizer: Pick<DomSanitizer, 'bypassSecurityTrustUrl'>,
): { file: File; previewUrl: ReturnType<DomSanitizer['bypassSecurityTrustUrl']>; ownedPreviewObjectUrl?: string } | null {
    const defaultName = sourceFile?.name || 'image.jpg';
    const defaultType = sourceFile?.type || 'image/jpeg';

    if (event.blob) {
        const type = event.blob.type || defaultType;
        const file = new File([event.blob], defaultName, { type });
        let ownedPreviewObjectUrl: string | undefined;
        const previewSource = event.objectUrl || (ownedPreviewObjectUrl = URL.createObjectURL(event.blob));
        return {
            file,
            previewUrl: sanitizer.bypassSecurityTrustUrl(previewSource),
            ownedPreviewObjectUrl,
        };
    }

    if (event.base64) {
        const blob = base64ToFile(event.base64);
        const file = new File([blob], defaultName, { type: defaultType });
        const previewSource = event.base64.startsWith('data:')
            ? event.base64
            : `data:${defaultType};base64,${event.base64}`;
        return {
            file,
            previewUrl: sanitizer.bypassSecurityTrustUrl(previewSource),
        };
    }

    return null;
}
